import UserAffirmationProgramService from 'src/modules/userAffirmationProgram/userAffirmationProgramService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'USERAFFIRMATIONPROGRAM_FORM';

const userAffirmationProgramFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: userAffirmationProgramFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await UserAffirmationProgramService.find(id);
      }

      dispatch({
        type: userAffirmationProgramFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: userAffirmationProgramFormActions.INIT_ERROR,
      });

      getHistory().push('/user-affirmation-program');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: userAffirmationProgramFormActions.CREATE_STARTED,
      });

      await UserAffirmationProgramService.create(values);

      dispatch({
        type: userAffirmationProgramFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.userAffirmationProgram.create.success'),
      );

      getHistory().push('/user-affirmation-program');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: userAffirmationProgramFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: userAffirmationProgramFormActions.UPDATE_STARTED,
      });

      await UserAffirmationProgramService.update(id, values);

      dispatch({
        type: userAffirmationProgramFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.userAffirmationProgram.update.success'),
      );

      getHistory().push('/user-affirmation-program');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: userAffirmationProgramFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default userAffirmationProgramFormActions;
